import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, insideImages } from '../data/content';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insideImages.length - 1, i));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      setIndex(Math.max(0, Math.min(insideImages.length - 1, i)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-92" data-mp="a2o3oog3rxft">
      <div className="mx-auto max-w-2xl" data-id="element-93" data-mp="a1394ytsgehy">
        <h2 className="text-center text-[1.2rem] font-black uppercase text-navy sm:text-[1.8rem]" data-id="element-94" data-mp="612v3falq5bf">
          LOOK INSIDE
        </h2>
        <p className="mt-0.5 text-center font-heading text-[0.76rem] font-extrabold uppercase tracking-wide text-electric sm:text-[0.9rem]" data-id="element-95" data-mp="jzstcy95qb1d">
          See KITCHEN EQUIPMENT DIAGNOSTIC PRO™ In Action
        </p>
        <p className="mt-1 text-center text-[0.78rem] leading-[1.35] sm:text-[0.9rem]" data-id="element-96" data-mp="3nicbh7y4g0ig">
          Take a look inside the system and see the visual diagnostic references, troubleshooting
          workflows, component checks, diagrams and ready-to-use resources included.
        </p>

        <div className="relative mt-2" data-id="element-97" data-mp="3sgdrtl45xlq8">
          <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto rounded-md border-2 border-navy bg-ice" role="group" aria-roledescription="carousel" aria-label="Interior pages of Kitchen Equipment Diagnostic Pro" tabIndex={0} data-id="element-98" data-mp="3sfcf7c7i0r6e">
            {insideImages.map((img, i) => <a key={img.src} href={PURCHASE_ANCHOR} className="flex w-full shrink-0 snap-center items-center p-1.5" aria-label={`Page ${i + 1} of ${insideImages.length} — get the complete system`} data-id="element-99" data-mp="18m3p83m251c8" data-mpi={i}>
                <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} className="mx-auto w-full rounded-sm bg-white shadow-md" data-id="element-100" data-mp="krar5lg4h92i" />
              </a>)}
          </div>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 -translate-y-1/2 rounded-full border-2 border-gold bg-navy/90 p-1.5 text-white shadow-md transition-colors duration-150 ease-out hover:bg-navy disabled:opacity-30" data-id="element-101" data-mp="yq0nuzz156qc">
            <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-102" data-mp="2f99cnebp6kbt" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === insideImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 -translate-y-1/2 rounded-full border-2 border-gold bg-navy/90 p-1.5 text-white shadow-md transition-colors duration-150 ease-out hover:bg-navy disabled:opacity-30" data-id="element-103" data-mp="2aisxnps8aqnc">
            <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-104" data-mp="1rjncooni412r" />
          </button>
        </div>

        <div className="mt-1.5 flex items-center justify-center gap-1.5" data-id="element-105" data-mp="1nj3eriv3stfk">
          {insideImages.map((img, i) => <button key={img.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-[width,background-color] duration-150 ease-out ${i === index ? 'w-5 bg-gold' : 'w-1.5 bg-navy/25'}`} data-id="element-106" data-mp="3lx6j6nzieu07" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}